module.exports = __webpack_public_path__ + "static/ec-woman-photo-517bde2406b4e196f69966802f5aa4bc.png";